/* Bombardina Custom storefront interactivity. Written independently. */
(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const shop = window.Bombardina || {};
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function money(cents, currency = 'EUR') {
    try { return new Intl.NumberFormat((shop.locale || 'de') === 'de' ? 'de-DE' : shop.locale || 'de-DE', {style:'currency',currency}).format(Number(cents) / 100); }
    catch (_) { return (Number(cents) / 100).toFixed(2) + ' ' + currency; }
  }
  const toast = message => {
    const el = $('[data-toast]'); if (!el) return;
    el.textContent = message; el.classList.add('is-visible');
    clearTimeout(el._timer); el._timer = setTimeout(() => el.classList.remove('is-visible'), 3600);
  };
  async function getCart() {
    const res = await fetch((shop.cartUrl || '/cart') + '.js', {credentials:'same-origin'});
    if (!res.ok) throw new Error('Warenkorb konnte nicht geladen werden');
    return res.json();
  }
  const drawer = $('[data-cart-drawer]');
  const scrim = $('[data-drawer-scrim]');
  let activeModal = null;
  let returnFocus = null;
  function setBodyLock() {
    document.body.classList.toggle('no-scroll', !!activeModal);
    if (scrim) scrim.hidden = !activeModal;
    $$('[data-mobile-open]').forEach(el => el.setAttribute('aria-expanded', String(activeModal === $('[data-mobile-nav]'))));
    $$('[data-cart-open]').forEach(el => el.setAttribute('aria-expanded', String(activeModal === drawer)));
  }
  function openModal(el, trigger = document.activeElement) {
    if (!el) return;
    if (activeModal && activeModal !== el) {
      activeModal.classList.remove('is-open');
      activeModal.setAttribute('aria-hidden', 'true');
      activeModal.inert = true;
    }
    if (!activeModal && trigger) returnFocus = trigger;
    activeModal = el;
    el.inert = false;
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('is-open');
    setBodyLock();
    requestAnimationFrame(() => {
      if (activeModal === el) ($('[data-mobile-close]', el) || $('[data-drawer-close]', el))?.focus({preventScroll: true});
    });
  }
  function closeModal() {
    if (!activeModal) return;
    const previous = activeModal;
    activeModal = null;
    previous.classList.remove('is-open');
    previous.setAttribute('aria-hidden', 'true');
    previous.inert = true;
    setBodyLock();
    if (returnFocus && returnFocus.isConnected && returnFocus.offsetParent !== null) returnFocus.focus({preventScroll:true});
    returnFocus = null;
  }
  function setNavExpanded(group, expanded) {
    const button = $('[data-nav-toggle]', group);
    const panel = $('[data-nav-panel]', group);
    if (!button || !panel) return;
    group.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    panel.setAttribute('aria-hidden', String(!expanded));
    panel.inert = !expanded;
    panel.style.maxHeight = expanded ? panel.scrollHeight + 'px' : '0px';
    // A second-level submenu changes the scroll height of every expanded ancestor.
    let ancestor = group.parentElement?.closest('[data-nav-group]');
    while (ancestor) {
      const parentPanel = $('[data-nav-panel]', ancestor);
      if (parentPanel && ancestor.classList.contains('is-expanded')) {
        parentPanel.style.maxHeight = parentPanel.scrollHeight + (expanded ? panel.scrollHeight : 0) + 'px';
      }
      ancestor = ancestor.parentElement?.closest('[data-nav-group]');
    }
  }
  function toggleNavGroup(button) {
    const group = button.closest('[data-nav-group]');
    if (!group) return;
    const expanded = !group.classList.contains('is-expanded');
    // Keep the level tidy, without closing nested groups until the parent closes.
    if (expanded) {
      const siblings = [...group.parentElement.children].filter(el=>el !== group && el.matches?.('[data-nav-group].is-expanded'));
      siblings.forEach(el => setNavExpanded(el, false));
    }
    setNavExpanded(group, expanded);
  }
  function updateCount(cart) { $$('[data-cart-count]').forEach(el => {el.textContent = cart.item_count; el.hidden = cart.item_count === 0;}); }
  function displayCart(cart) {
    updateCount(cart);
    const body = $('[data-cart-body]'), subtotal = $('[data-cart-subtotal]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty-state"><p>Dein Warenkorb ist noch leer.</p><a class="btn btn--outline" href="/collections/all">Weiter einkaufen</a></div>';
    } else {
      body.innerHTML = cart.items.map((item, index) => {
        const image = item.image ? '<img loading="lazy" alt="" src="' + escapeHtml(item.image.replace(/(\.[\w]+)(\?.*)?$/, '_160x$1')) + '">' : '';
        const opts = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line-meta">'+escapeHtml(item.variant_title)+'</div>' : '';
        return `<div class="cart-line" data-cart-line="${index + 1}"><a href="${escapeHtml(item.url)}">${image}</a><div><a href="${escapeHtml(item.url)}" class="cart-line-title">${escapeHtml(item.product_title)}</a>${opts}<div class="cart-line-price">${money(item.final_line_price, cart.currency)}</div><div class="cart-line-actions"><div class="quantity-stepper"><button type="button" data-line-qty="${index+1}" data-qty="${item.quantity-1}" aria-label="Menge verringern">−</button><span>${item.quantity}</span><button type="button" data-line-qty="${index+1}" data-qty="${item.quantity+1}" aria-label="Menge erhöhen">+</button></div><button type="button" class="remove-line" data-line-qty="${index+1}" data-qty="0">Entfernen</button></div></div></div>`;
      }).join('');
    }
    if (subtotal) subtotal.textContent = money(cart.total_price, cart.currency);
    const foot = $('[data-cart-foot]'); if (foot) foot.hidden = cart.item_count === 0;
  }
  async function refreshCart(shouldOpen = false) {
    if (shouldOpen && drawer) {
      openModal(drawer, $('[data-cart-open]'));
      const body = $('[data-cart-body]');
      if (body) body.innerHTML = '<div class="empty-state" role="status">Warenkorb wird geladen …</div>';
    }
    try {
      const cart = await getCart();
      displayCart(cart);
    } catch(e) {
      if (shouldOpen && drawer) {
        const body = $('[data-cart-body]');
        if (body) body.innerHTML = '<div class="empty-state"><p>Der Warenkorb konnte nicht geladen werden.</p><a class="btn btn--outline" href="' + escapeHtml(shop.cartUrl || '/cart') + '">Warenkorb anzeigen</a></div>';
      } else { console.warn('Warenkorb:', e); }
    }
  }
  async function addToCart(form) {
    const submit = $('[type=submit]', form);
    if (submit) { submit.disabled = true; submit.dataset.oldText = submit.textContent; submit.textContent = 'Wird hinzugefügt …'; }
    try {
      const res = await fetch((shop.cartAddUrl || '/cart/add') + '.js', {method:'POST',body:new FormData(form),credentials:'same-origin',headers:{Accept:'application/json'}});
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Artikel konnte nicht hinzugefügt werden');
      await refreshCart(true);
    } catch(e) { toast(e.message || 'Ein Fehler ist aufgetreten'); }
    finally { if (submit) { submit.disabled = false; submit.textContent = submit.dataset.oldText || 'In den Warenkorb'; } }
  }
  async function changeQuantity(line, quantity) {
    try {
      const res = await fetch((shop.cartChangeUrl || '/cart/change') + '.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:Number(line),quantity:Number(quantity)}),credentials:'same-origin'});
      const cart = await res.json(); if (!res.ok) throw new Error(cart.description || 'Änderung nicht möglich'); displayCart(cart);
    } catch(e) { toast(e.message); }
  }
  function setupSlideshow(slider) {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';
    const slides = $$('[data-slide]', slider), dots = $$('[data-slide-to]', slider);
    if (!slides.length) return;
    let current = Math.max(0, slides.findIndex(el => el.classList.contains('is-active')));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const toggle = $('[data-autoplay-toggle]', slider);
    let timer = null, focused = false, inView = true, editorSelected = false;
    let paused = reduceMotion.matches;
    const autoplayMs = Math.max(0, Number(slider.dataset.autoplay || 0)) * 1000;
    const stop = () => { if (timer !== null) { clearInterval(timer); timer = null; } };
    const canPlay = () => slides.length > 1 && autoplayMs > 0 && !paused && !focused && !editorSelected && inView && !document.hidden;
    function updateToggle() {
      if (!toggle) return;
      toggle.hidden = slides.length < 2 || autoplayMs === 0;
      toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      $('[data-autoplay-symbol]', toggle).textContent = paused ? '▶' : 'Ⅱ';
    }
    function play() {
      stop();
      if (canPlay()) timer = setInterval(() => show(current + 1), autoplayMs);
    }
    function show(next) {
      current = (next + slides.length) % slides.length;
      slides.forEach((slide,i) => {
        const active = i === current;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot,i) => {
        dot.classList.toggle('is-active',i===current);
        if (i===current) dot.setAttribute('aria-current','true');
        else dot.removeAttribute('aria-current');
      });
    }
    if (slides.length <= 1) $$('[data-slide-control]', slider).forEach(button => button.hidden = true);
    $$('[data-slide-control]',slider).forEach(button => button.addEventListener('click', () => {
      show(current + (button.dataset.slideControl === 'next' ? 1 : -1)); play();
    }));
    dots.forEach(button => button.addEventListener('click', () => {show(Number(button.dataset.slideTo)); play();}));
    toggle?.addEventListener('click',()=>{paused = !paused;focused = false;updateToggle();play();});
    slider.addEventListener('focusin',event=>{
      focused = !event.target.closest('[data-autoplay-toggle]') && (event.target.matches(':focus-visible') || !event.target.closest('[data-slide-control],[data-slide-to]'));
      play();
    });
    slider.addEventListener('focusout',e=>{if (!slider.contains(e.relatedTarget)) {focused = false;play();}});
    slider.addEventListener('keydown',e=>{
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();show(current + (e.key === 'ArrowRight' ? 1 : -1));play();
      }
    });
    let touchX = 0, touchY = 0;
    slider.addEventListener('touchstart',e => {if (e.touches.length===1) {touchX=e.touches[0].clientX;touchY=e.touches[0].clientY;}}, {passive:true});
    slider.addEventListener('touchend',e => {
      if (!e.changedTouches.length) return;
      const dx=e.changedTouches[0].clientX-touchX, dy=e.changedTouches[0].clientY-touchY;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)*1.3) {show(current + (dx < 0 ? 1 : -1));play();}
    },{passive:true});
    let observer;
    if ('IntersectionObserver' in window) {
      observer=new IntersectionObserver(entries=>{inView = !!entries[0]?.isIntersecting; play();},{threshold:.15});
      observer.observe(slider);
    }
    document.addEventListener('visibilitychange',play);
    const motionChanged = () => {paused = reduceMotion.matches;updateToggle();play();};
    reduceMotion.addEventListener?.('change',motionChanged);
    slider.addEventListener('shopify:block:select',event=>{
      const selected=slides.findIndex(slide=>slide.contains(event.target) || slide===event.target);
      if(selected >= 0){show(selected);editorSelected=true;stop();}
    });
    slider.addEventListener('shopify:block:deselect',()=>{editorSelected=false;play();});
    slider._destroySlideshow = () => {
      stop();
      observer?.disconnect();
      document.removeEventListener('visibilitychange',play);
      reduceMotion.removeEventListener?.('change',motionChanged);
    };
    show(current);updateToggle();play();
  }
  function setupProduct(root) {
    if (root.dataset.initialized) return; root.dataset.initialized='true';
    const json = $('[data-variants-json]',root); const form = $('.product-form',root);
    if (!json || !form) return;
    let variants = [];
    try { variants=JSON.parse(json.textContent); } catch(_) { return; }
    const idInput = $('[name="id"]',form), price=$('[data-product-price]',root), oldPrice=$('[data-product-compare]',root), add=$('[data-product-submit]',root), hero=$('[data-primary-image]',root);
    const radios = $$('[data-option-index]',root);
    const pickVariant = () => {
      const selected = [...new Set(radios.map(el=>Number(el.dataset.optionIndex)))].sort().map(index=>{
        const radio=$(`[data-option-index="${index}"]:checked`,root);return radio?radio.value:null;
      });
      const variant=variants.find(v=>v.options.every((vOption,i)=>vOption===selected[i]));
      $$('.option-field',root).forEach((field,i)=>{const label=$('.muted',field);if(label && selected[i])label.textContent=selected[i];});
      if (variant) {
        idInput.value=variant.id;
        if(price) {price.textContent=money(variant.price,root.dataset.currency || 'EUR');price.classList.toggle('price-new',variant.compare_at_price>variant.price);}
        if(oldPrice){oldPrice.textContent=variant.compare_at_price > variant.price ? money(variant.compare_at_price,root.dataset.currency || 'EUR'):'';oldPrice.hidden=!(variant.compare_at_price > variant.price);}
        if(add) {add.disabled=!variant.available;add.textContent=variant.available?'In den Warenkorb':'Ausverkauft';}
        if(variant.featured_image && hero){hero.src=variant.featured_image.src; const thumbs=$$('[data-gallery-thumb]',root); thumbs.forEach(btn=>btn.classList.toggle('is-active',btn.dataset.imageId===String(variant.featured_image.id)));}
        const url=new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState(history.state,'',url.pathname+url.search);
      } else if(add) {add.disabled=true;add.textContent='Nicht verfügbar';}
    };
    radios.forEach(radio=>radio.addEventListener('change',pickVariant));
    $$('[data-gallery-thumb]',root).forEach(btn=>btn.addEventListener('click',()=>{
      if(hero) {hero.src=btn.dataset.imageSrc;hero.alt=btn.dataset.imageAlt || '';} $$('[data-gallery-thumb]',root).forEach(el=>el.classList.toggle('is-active',el===btn));
    }));
    const zoom=$('[data-zoom-dialog]',root);const zoomImg=$('[data-zoom-image]',root);
    $('[data-zoom-open]',root)?.addEventListener('click',()=>{if(zoom && zoomImg && hero){zoomImg.src=hero.src;zoom.showModal();}});
    $('[data-zoom-close]',root)?.addEventListener('click',()=>zoom?.close());
    $('[data-size-open]',root)?.addEventListener('click',()=> $('[data-size-dialog]',root)?.showModal());
    $('[data-size-close]',root)?.addEventListener('click',()=> $('[data-size-dialog]',root)?.close());
  }
  let searchController;
  async function suggest(input, target) {
    if (!target) return;
    const term=input.value.trim(); if(term.length < 2){target.innerHTML='';return;}
    if(searchController) searchController.abort(); searchController=new AbortController();
    try {
      const base=shop.searchSuggestUrl || '/search/suggest';
      const response=await fetch(`${base}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5`,{signal:searchController.signal});
      if(!response.ok) return;const data=await response.json();const products=data.resources?.results?.products || [];
      target.innerHTML=products.map(p=>`<a href="${escapeHtml(p.url)}">${p.featured_image?.url?`<img src="${escapeHtml(p.featured_image.url)}" loading="lazy" alt="">`:''}<span>${escapeHtml(p.title)}</span></a>`).join('');
    } catch(e){if(e.name!=='AbortError')target.innerHTML='';}
  }
  let searchTimer;
  function init(root=document) {$$('[data-hero-slider]',root).forEach(setupSlideshow);$$('[data-product-root]',root).forEach(setupProduct);}
  document.addEventListener('click', event=>{
    const el=event.target.closest('button,a'); if(!el) return;
    if(el.matches('[data-mobile-open]')){event.preventDefault();openModal($('[data-mobile-nav]'), el);}
    if(el.matches('[data-mobile-close],[data-drawer-close]')){event.preventDefault();closeModal();}
    if(el.matches('[data-cart-open]')){event.preventDefault();refreshCart(true);}
    if(el.matches('[data-search-toggle]')){event.preventDefault();const panel=$('[data-search-panel]');const isOpen=panel?.classList.toggle('is-open');el.setAttribute('aria-expanded',String(!!isOpen));if(isOpen)panel?.querySelector('input')?.focus();}
    if(el.matches('[data-nav-toggle]')){event.preventDefault();toggleNavGroup(el);}
    if(el.closest('[data-mobile-nav]') && el.matches('a[href]')) closeModal();
    if(el.matches('[data-line-qty]')){event.preventDefault();changeQuantity(el.dataset.lineQty,el.dataset.qty);}
    if(el.matches('[data-filter-toggle]')){event.preventDefault();$('[data-filter-panel]')?.classList.toggle('is-open');}
    if(el.matches('[data-filter-reset]')){event.preventDefault();window.location.href=el.dataset.filterReset || location.pathname;}
  });
  scrim?.addEventListener('click',closeModal);
  document.addEventListener('keydown',event=>{if(event.key==='Escape')closeModal();});
  window.matchMedia('(min-width: 801px)').addEventListener?.('change', event => {if(event.matches && activeModal === $('[data-mobile-nav]'))closeModal();});
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(form.matches('.product-form')){event.preventDefault();addToCart(form);}
  });
  document.addEventListener('input',event=>{
    const input=event.target;if(!input.matches('[data-search-input]'))return;
    clearTimeout(searchTimer);const target=$('[data-search-suggestions]');searchTimer=setTimeout(()=>suggest(input,target),280);
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-sort-select]')){const url = new URL(location.href);url.searchParams.set('sort_by',event.target.value);location.href=url.toString();}
    if(event.target.matches('[data-cart-terms]')){const btn=$('[data-cart-checkout]',event.target.closest('form'));if(btn)btn.disabled=!event.target.checked;}
  });
  function setupRecentlyViewed() {
    const root = $('[data-product-root]');
    try {
      let items=JSON.parse(localStorage.getItem('bombardina-recent') || '[]');
      if (root && root.dataset.recentUrl) {
        const entry={url:root.dataset.recentUrl,title:root.dataset.recentTitle,price:root.dataset.recentPrice,image:root.dataset.recentImage};
        items=[entry,...items.filter(item=>item.url!==entry.url)].slice(0,12);
        localStorage.setItem('bombardina-recent',JSON.stringify(items));
      }
      $$('[data-recent-viewed]').forEach(section=>{
        const list=$('[data-recent-items]',section);
        const visible=items.filter(item=>!root || item.url!==root.dataset.recentUrl).slice(0,5);
        if (!list || !visible.length) {section.hidden=true;return;}
        list.innerHTML=visible.map(item=>`<article class="product-card"><a class="product-card-image product-card-image--square" href="${escapeHtml(item.url)}">${item.image?`<img alt="${escapeHtml(item.title)}" loading="lazy" src="${escapeHtml(item.image)}">`:''}</a><div class="product-card-details"><a class="product-card-name" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a><div class="product-prices">${escapeHtml(item.price)}</div></div></article>`).join('');
      });
    } catch(_) { $$('[data-recent-viewed]').forEach(section=>section.hidden=true); }
  }
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>$$('[data-hero-slider]',event.target).forEach(slider=>slider._destroySlideshow?.()));
  document.addEventListener('DOMContentLoaded',()=>{init();setupRecentlyViewed();refreshCart(false);});
})();
